var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-wrapper pt-5 pb-5"},[_c('b-container',[_c('b-row',{staticClass:"align-items-center"},[_c('b-col',{staticClass:"mx-auto",attrs:{"cols":"12","md":"6"}},[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }